import { render } from "./VariantsTable.vue?vue&type=template&id=47bf05a4&ts=true"
import script from "./VariantsTable.vue?vue&type=script&lang=ts"
export * from "./VariantsTable.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__